<template>

<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.71 1.47583C20.1381 1.47583 22.2239 2.94182 23.1305 5.03699L11.8066 16.3608V7.37916C11.8066 4.11884 14.4497 1.47583 17.71 1.47583Z" fill="white"/>
<path d="M9.22401 17.71C9.22401 18.0985 9.25063 18.4841 9.30289 18.8646L6.27525 21.8922C5.78971 20.5649 5.53442 19.1506 5.53442 17.71V17.4795C5.53442 16.6644 6.19518 16.0037 7.01026 16.0037H7.74817C8.56326 16.0037 9.22401 16.6644 9.22401 17.4795V17.71Z" fill="white"/>
<path d="M10.8093 27.7413L5.56054 32.99C4.98418 33.5665 4.04975 33.5665 3.4734 32.99L2.42983 31.9464C1.85347 31.3701 1.85347 30.4356 2.42983 29.8593L29.8594 2.42983C30.4357 1.85347 31.3702 1.85347 31.9465 2.42983L32.99 3.47339C33.5664 4.04975 33.5664 4.98418 32.99 5.56054L23.6133 14.9373V17.71C23.6133 20.9702 20.9703 23.6133 17.71 23.6133C16.8919 23.6133 16.1127 23.447 15.4045 23.1462L13.4825 25.068C14.7579 25.8008 16.2135 26.196 17.71 26.196C19.9606 26.196 22.119 25.3019 23.7104 23.7105C25.302 22.119 26.196 19.9606 26.196 17.71V17.4794C26.196 16.6643 26.8568 16.0036 27.6719 16.0036H28.4098C29.2249 16.0036 29.8856 16.6643 29.8856 17.4793V17.71C29.8856 20.9391 28.6028 24.0361 26.3194 26.3194C24.4755 28.1634 22.101 29.3547 19.5548 29.7451V33.9441H15.8652V29.7451C14.0491 29.4667 12.3204 28.7808 10.8093 27.7413Z" fill="white"/>
</svg>


</template>

<script>
export default {
  name: 'IconBtnMicroOff',
  components: {
  },

  data: () => {
    return {
    }
  },

  mounted () {
  },

  methods: {
  }
}
</script>
